<script>
export default {
  name: "CamoLog",
  data() {
    return {
      plovila: [],
      startne: [],
      //NOTIFICATION
      ShowNoti: false,
      text: '',
      types: '',
    }
  },
  mounted() {
    this.BeriPodatke();
  },
  methods: {
    BeriPodatke() {
      axios.get('./api/camo/logi', {withCredentials: true}).then(response => {
        this.plovila = response.data.plovila;
        this.startne = response.data.startne;
      }).catch((error) => {
        this.text = error.response.data.napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    }
  }
}
</script>

<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>
        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title"> Camo - pregled logov</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="deleted-flights-container">

    <!-- Plovila -->
    <section class="flight-section">

      <div class="section-header">
        <div class="section-icon glider">
          <i class="fas fa-paper-plane"></i>
        </div>

        <div>
          <h2>Plovila</h2>
          <span>{{ plovila.length }} zapisov</span>
        </div>
      </div>


      <div class="flight-list">

        <div
            class="flight-item"
            v-for="(id, index) in plovila"
            :key="id.id"
            @click.prevent="OpenView('j', id.id)"
        >

          <div class="flight-date">
            <i class="far fa-calendar-alt"></i>
            <span>{{ id.datum }} <br/> {{ id.pregledal }}</span>
          </div>

        <div class="flight-user">
            <span class="label">Registracija</span>
           <strong>{{ id.podatki.registracija }}</strong>
         </div>

        <div class="flight-task">
          <span class="label">Akcija</span>
          <strong><i class="fas fa-1x" :class="{'fa-print': id.izpis === 'tisk', 'fa-envelope': id.izpis !== 'tisk'}"></i> {{ id.izpis.toUpperCase() }}</strong>
        </div>

          <div class="flight-action">
            <i class="fas fa-chevron-right"></i>
          </div>

        </div>

        <div v-if="!plovila.length" class="empty-state">
          <i class="far fa-folder-open"></i>
          <span>Ni podatkov</span>
        </div>

      </div>

    </section>


    <!-- Motorni leti -->
    <section class="flight-section" v-for="(zapisi, start) in startne">

      <div class="section-header">
        <div class="section-icon motor">
          <i class="fas fa-plane"></i>
        </div>

        <div>
          <h2>Štartne liste - {{ start }}</h2>
          <span>{{ zapisi.length }} zapisov</span>
        </div>
      </div>


      <div class="flight-list">

        <div
            class="flight-item"
            v-for="(id, index) in zapisi"
            :key="id.id"
            @click.prevent="OpenView('m', id.id)"
        >

          <div class="flight-date">
            <i class="far fa-calendar-alt"></i>
            <span>{{ id.datum }} <br/> {{ id.pregledal }}</span>
          </div>

         <div class="flight-user">
           <span class="label">Izpisano obdobje</span>
           <strong>{{ id.podatki.datumO.split('-').reverse().join('.') }} - {{ id.podatki.datumD.split('-').reverse().join('.') }}</strong>
         </div>

          <div class="flight-task">
            <span class="label">Akcija</span>
            <strong><i class="fas fa-1x" :class="{'fa-print': id.izpis === 'tisk', 'fa-envelope': id.izpis !== 'tisk'}"></i> {{ id.izpis.toUpperCase() }}</strong>
          </div>

          <div class="flight-action">
            <i class="fas fa-chevron-right"></i>
          </div>

        </div>

        <div v-if="!zapisi.length" class="empty-state">
          <i class="far fa-folder-open"></i>
          <span>Ni podatkov</span>
        </div>

      </div>

    </section>

  </div>
  <div class="mt-4 w-100"></div>
</template>

<style scoped>

</style>